var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-modal",
    { attrs: { value: "" } },
    [
      _c(
        "w-card",
        { attrs: { "max-width": "1200" } },
        [
          _c(
            "w-card-title",
            [
              _vm._v(
                " " +
                  _vm._s(
                    _vm.$ct("edit-layout-conditions", {
                      layout: _vm.layout.Name,
                    })
                  ) +
                  " "
              ),
              _c("w-spacer"),
              _c(
                "w-link",
                {
                  directives: [
                    {
                      name: "tooltip",
                      rawName: "v-tooltip",
                      value: _vm.$ct("common.close"),
                      expression: "$ct('common.close')",
                    },
                  ],
                  attrs: { white: "" },
                  on: {
                    click: function ($event) {
                      return _vm.close()
                    },
                  },
                },
                [_c("w-fa", { attrs: { icon: "times" } })],
                1
              ),
            ],
            1
          ),
          _c(
            "w-card-content",
            [
              _c("app-conditions-edit", {
                attrs: {
                  conditions: _vm.conditions,
                  fields: _vm.saleMapPropSelectGroup,
                },
              }),
            ],
            1
          ),
          _c(
            "w-card-actions",
            [
              _c(
                "w-button",
                {
                  staticClass: "cancel",
                  attrs: { disabled: _vm.saving, icon: "ban" },
                  on: {
                    click: function ($event) {
                      return _vm.close()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$ct("common.cancel")))]
              ),
              _c("w-spacer"),
              _c(
                "w-button",
                {
                  attrs: { disabled: _vm.saving, icon: "save" },
                  on: {
                    click: function ($event) {
                      return _vm.save()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$ct("common.save")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }